const {Component} = require("react");
const PropTypes = require("prop-types");
const Stars = require("components/mixins/Stars");
const router = require("services/router");
const {classList} = require("helpers/html");
const RatingTbd = require("components/mixins/RatingTbd");
const {enumerateWithRest, moneyFormat} = require("helpers/format");
const {encodeState} = require("helpers/url");
const {loaded} = require("bootstrap");
const anime = require("animejs");

class TeacherCard extends Component {

	static get propTypes() {
		return {
			id: PropTypes.number.isRequired,
			nickname: PropTypes.string.isRequired,
			username: PropTypes.string.isRequired,
			address: PropTypes.object.isRequired,
			subjects: PropTypes.any.isRequired,
			allBadges: PropTypes.any,
			hourly_rate: PropTypes.number,
			received_reviews: PropTypes.any.isRequired,
			levels: PropTypes.any.isRequired,
			average_rating: PropTypes.any,
			locationRef: PropTypes.any,
			levelRef: PropTypes.any,
			instant_booking_enabled: PropTypes.bool,
			order: PropTypes.number,
		};
	}

	static get deafultProps() {
		return {
			order: 1,
		};
	}

	componentDidMount() {
		loaded.then(this.animateIn);
	}

	/////////////////////////////////
	// Accessors
	/////////////////////////////////

	get avatarUrl() {
		return this.props.avatar ? this.props.avatar.url : router.url("img/avatar-placeholder.png");
	}

	get routeParams() {
		let params = {username: this.props.username};

		if (this.props.locationRef && (typeof this.props.locationRef === "object")) {
			params.state = encodeState(this.props.locationRef);
		}

		return params;
	}

	get profileUrl() {
		return router.route("profile", this.routeParams);
	}

	get distanceToReference() {
		return typeof this.props.distance_to_reference === "number" ?
			`${this.props.distance_to_reference} km væk` : "";
	}

	get subjects() {
		let {subjects} = this.props;

		if (this.props.levelRef) {
			subjects = subjects.filter(subject => subject.levels.indexOf(this.props.levelRef) > -1);
		}

		return enumerateWithRest(subjects.map(subject => subject.name), 2);
	}

	get levels() {
		let {levels} = this.props;

		if (this.props.levelRef) {
			levels = levels.filter(level => level.id === this.props.levelRef);
		}

		return enumerateWithRest(levels.map(level => level.name), 1);
	}

	get price() {
		return this.props.hourly_rate;
	}

	get className() {
		return classList(
			"teacher-box",
			this.props.instant_booking_enabled && "instant",
			this.hasBadges && this.props.instant_booking_enabled && "badges-instant",
			this.props.className
		);
	}

	get hasBadges() {
		return this.props.allBadges && this.props.allBadges.length > 0;
	}

	/////////////////////////////////
	// Methods
	/////////////////////////////////

	animateIn = () => {
		const delay = 150 * this.props.order;

		anime({
			targets: this.element,
			opacity: [0, 1],
			translateY: [10*(this.props.order+1), 0],
			duration: 700,
			easing: 'easeOutCubic',
			delay: delay
		});

		// anime({
		// 	targets: this.element,
		// 	opacity: [0, 1],
		// 	duration: 600,
		// 	easing: 'linear',
		// 	delay: delay + 300
		// });
	}

	/////////////////////////////////
	// Rendering
	/////////////////////////////////

	renderRating() {
		const reviews = this.props.received_reviews.length;

		if (reviews < 1) return null;

		const word = reviews === 1 ?
			'Anmeldelse' :
			'Anmeldelser';

		return (
			<div className="teacher-content-row">
				<Stars filled={this.props.average_rating || 0}/>
				<span>{reviews} {word}</span>
			</div>
		);
	}

	renderBadges() {
		if (!this.hasBadges) return;

		const badges = this.props.allBadges;

		const badgesMarkup = badges.map((badge, index) => {
			return (<div key={index} className="badge"><img src={badge.image_url} /><span>{badge.name}</span></div>);
		});

		return (
			<div className="badges">
				<div className="badge-placeholder"><span>Alle badges</span></div>
				{badgesMarkup}
			</div>
		);
	}

	render() {
		return (
			<div ref={el => this.element = el} style={{opacity: 0}} className={this.className}>
				<div className="img-box object-fit" >
					<a href={this.profileUrl}>
						<img src={this.avatarUrl} alt={this.props.nickname}/>
					</a>
					{this.renderBadges()}
				</div>

				<div className="teacher-description">
					<div className="teacher-content">
						<div className="teacher-content-row">
							<a href={this.profileUrl} className="name">{this.props.nickname}</a>
						</div>

						{this.renderRating()}
					</div>

					<div className="teacher-content dotted">
						<div className="teacher-content-row">
							<p>{this.props.address.city}</p>
							<span>{this.distanceToReference}</span>
						</div>
						<div className="teacher-content-row">
							<p>{this.levels}</p>
							<span>{this.subjects}</span>
						</div>
					</div>

					<div className="teacher-content">
						<div className="teacher-content-row">
							<p>{moneyFormat(this.price)}</p>
							<span>Pr. time</span>
						</div>
					</div>

				</div>

			</div>
		);
	}

}

module.exports = TeacherCard;



// WEBPACK FOOTER //
// ./resources/js/components/frontend/TeacherCard.js